module.exports = __webpack_public_path__ + "static/img/zhuanli-3.d1b5c17f.png";